/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trackTypeEnumSchema } from "./trackTypeEnumSchema.ts";
import { z } from "zod";

export const updateTrackModelSchema = z.object({
    "name": z.string().max(150).describe("Название"),
"description": z.string().max(2000).describe("Описание").nullable().nullish(),
"authorId": z.string().uuid().describe("Идентификатор основного автора").nullable().nullish(),
"coauthorIds": z.array(z.string().uuid()).describe("Идентификаторы соавторов").nullable().nullish(),
"type": z.lazy(() => trackTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Sermon</b>: Проповедь</li>\n<li><b>4 - Book</b>: Аудиокнига</li>\n<li><b>5 - Jingle</b>: Джингл</li>\n</ul>\n"),
"genreIds": z.array(z.number().int()).describe("Идентификаторы жанров").nullable().nullish(),
"moodIds": z.array(z.number().int()).describe("Идентификаторы тегов настроения").nullable().nullish(),
"albumId": z.string().uuid().describe("Идентификатор альбома").nullable().nullish(),
"useAlbumPicture": z.boolean().describe("Использовать обложку альбома"),
"pictureFileId": z.string().uuid().describe("Идентификатор файла-обложки (null в случае, если используется обложка альбома)").nullable().nullish(),
"fileIds": z.array(z.string().uuid()).describe("Файлы треков"),
"releaseDate": z.string().date().describe("Дата выпуска").nullable().nullish()
    })